export default {
  helpText: 'Wybierz i uporządkuj kolumny wyświetlane w tabeli przeglądu części. To ustawienie obowiązuje globalnie dla wszystkich użytkowników.',
  selectedColumns: 'Wybrane kolumny',
  nonSelectedColumns: 'Dostępne kolumny',
};
